import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Trans } from "@lingui/macro";
import { ContactPointCard } from "./contact-point-card";
import { ContactPointRow } from "./contact-point-row";
import { SocialContact } from "./social-contact";
import theme from "../../../theme-admin";
import config from "../../../config";

const useStyles = makeStyles((th) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: th.palette.tertiaryColor || th.palette.primary.main,
    color: th.palette.white,
    padding: "16px 0",
    borderTop: "1px solid #ddd",
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "0 16px",
    [th.breakpoints.down("xs")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  contactTitle: {
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  contactContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    width: "100%",
    gap: th.spacing(2),
    justifyContent: "center",
    padding: th.spacing(2),
    paddingBottom: th.spacing(0),
  },
}));

export default function Contact() {
  const classes = useStyles(theme);
  const { facebook, twitter, instagram } = config.SOCIAL_LINKS || {};
  const contactPoints = config.CONTACT_POINTS || [];

  if (!contactPoints.length && !facebook && !twitter && !instagram) return null;

  return (
    <Box className={classes.container}>
      <Box className={classes.topRow}>
        <Typography variant="h2" className={classes.contactTitle}>
          <Trans>Contact Us</Trans>
        </Typography>
        {contactPoints.length === 1 && <ContactPointRow contact={contactPoints[0]} />}
        <SocialContact instagram={instagram} facebook={facebook} twitter={twitter} />
      </Box>

      {contactPoints.length > 1 && (
        <Box className={classes.contactContainer}>
          {contactPoints.map((contact, index) => (
            <ContactPointCard key={index} contact={contact} />
          ))}
        </Box>
      )}
    </Box>
  );
}
